import type { ComponentPropsWithRef } from "react";
import { forwardRef } from "react";
import { TextRenderer } from "@/react/components/shared/BuilderUI/DefaultBlocks/Content/RichText/TextRenderer";
import { classNames } from "@circle-react/helpers/twMergeWithCN";
import type { StyleValue } from "@circle-react-shared/BuilderUI/StyleValue.types";
import { parseStyles } from "@circle-react-shared/BuilderUI/utils/parseStyles";
import { defaultStyles } from "./defaultStyles";

interface CodeBlockProps extends ComponentPropsWithRef<"code"> {
  blockPath: string;
  styles: Record<string, StyleValue>;
  text: string;
}

export const CodeBlock = forwardRef<HTMLElement, CodeBlockProps>(
  ({ text, blockPath, styles, className, ...rest }, ref) => {
    const inlineStyles = parseStyles({ styles, defaultStyles });

    return (
      <code
        ref={ref}
        className={classNames(
          "wb-text-primary wb-text-lg wb-font-medium wb-tracking-wide",
          className,
        )}
        data-testid="builder-code"
        style={inlineStyles}
        {...rest}
      >
        <TextRenderer blockPath={blockPath} text={text} />
      </code>
    );
  },
);

CodeBlock.displayName = "CodeBlock";
